import React from 'react';
import ToolCard from './ToolCard';
import { useTranslation } from '../../contexts/LanguageContext';

function Skeleton() {
  return (
    <div className="tool-card" style={{ cursor: 'default', pointerEvents: 'none' }}>
      <div className="skeleton" style={{ height: 44, width: 44, borderRadius: 12, marginBottom: 14 }} />
      <div className="skeleton" style={{ height: 16, width: '55%', marginBottom: 8 }} />
      <div className="skeleton" style={{ height: 12, width: '90%', marginBottom: 4 }} />
      <div className="skeleton" style={{ height: 12, width: '70%' }} />
    </div>
  );
}

export default function ToolGrid({ tools, statusMap, loading, toolEnv, onEnvChange }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="tool-grid">
        <Skeleton /><Skeleton /><Skeleton />
      </div>
    );
  }

  if (!tools || tools.length === 0) {
    return (
      <div className="tool-grid">
        <div style={{ color: 'var(--text-muted)', padding: '32px 0' }}>
          {t('dashboard.noTools')}
        </div>
      </div>
    );
  }

  return (
    <div className="tool-grid">
      {tools.map((tool) => (
        <ToolCard
          key={tool.tool_id}
          tool={tool}
          liveStatus={statusMap?.[tool.tool_id]}
          selectedEnv={toolEnv?.[tool.tool_id]}
          onEnvChange={onEnvChange}
        />
      ))}
    </div>
  );
}
